import {Injectable, EventEmitter} from '@angular/core';
import {Router, ActivatedRouteSnapshot, Event, NavigationEnd} from '@angular/router';
import {Breadcrumb} from '../../interfaces/Breadcrumb';

@Injectable()
export class BreadcrumbService {
  breadcrumbChanged = new EventEmitter<Breadcrumb[]>(false);

  private breadcrumbs: Breadcrumb[] = [];
  private preparedRoutes = {};

  constructor(private router: Router) {
    this.router.events.subscribe((routeEvent) => {
      this.onRouteEvent(routeEvent);
    });
  }

  public changeBreadcrumb(route: ActivatedRouteSnapshot, name: string) {
    const rootUrl = this.createRootUrl(route);
    const breadcrumb = this.breadcrumbs.find(bc => bc.url === rootUrl);

    if (!breadcrumb) {
      return;
    }

    breadcrumb.displayName = name;

    this.breadcrumbChanged.emit(this.breadcrumbs);
  }

  public prepareBreadCrumb(fullUrl: string, name: string) {
     this.preparedRoutes[fullUrl] = name;
  }

  private onRouteEvent(routeEvent: Event) {
    if (!(routeEvent instanceof NavigationEnd)) {
      return;
    }

    let route = this.router.routerState.root.snapshot;
    let url = '';
    this.breadcrumbs = [];

    while (route.firstChild != null) {
      route = route.firstChild;

      if (route.routeConfig === null) {
        continue;
      }
      if (!route.routeConfig.path) {
        continue;
      }

      url += `/${this.createUrl(route)}`;

      if (!route.data['breadcrumb']) {
        continue;
      }

      this.breadcrumbs.push(this.createBreadcrumb(route, url));
    }
    this.breadcrumbChanged.emit(this.breadcrumbs);
  }

  private createBreadcrumb(route: ActivatedRouteSnapshot, url: string): Breadcrumb {
    const fullUrl = this.createRootUrl(route);
    const name = this.preparedRoutes[fullUrl] !== undefined
      ? this.preparedRoutes[fullUrl]
      : route.data['breadcrumb'];
    return {
      displayName: name,
      terminal: this.isTerminal(route),
      url: url
    }
  }

  private isTerminal(route: ActivatedRouteSnapshot) {
    return route.firstChild === null
      || route.firstChild.routeConfig === null
      || !route.firstChild.routeConfig.path;
  }

  private createUrl(route: ActivatedRouteSnapshot) {
    return route.url.map(function (s) {
      return s.toString();
    }).join('/');
  }

  /**
   *
   * @param {ActivatedRouteSnapshot} route
   * @return {string}
   */
  public createRootUrl(route: ActivatedRouteSnapshot): string {
    let url = '';
    let next = route.root;

    while (next.firstChild !== route && next.firstChild !== null) {
      next = next.firstChild;

      if (next.routeConfig === null) {
        continue;
      }
      if (!next.routeConfig.path) {
        continue;
      }

      url += `/${this.createUrl(next)}`;
    }

    url += `/${this.createUrl(route)}`;
    return this.trimTrailingSlash(url);
  }

  trimTrailingSlash(url) {
    return url.replace(/\/+$/, '')
  }
}



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/utilities/services/breadcrumb/breadcrumb.service.ts